/**
 * @ComponentFor Avensia.Shop.Features.Pantries.Pages.List.Toolbar.ActionOptions
 */
import React from "react";
import { translate } from "Shared/translate";
import DropDownMenu, { DropDownItem } from "Shared/DropDownMenu";
import NewListModal from "Shared/ListItem/NewListModal";
import * as styles from "./printOptions.scss";
import PrintActions from "./PrintActions";
import { DropDownListType } from ".";
import StartDialog from "./StartDialog";
import CloseDialog from "./CloseDialog";
const options = {};
const defaultName = "default";
const feedbackMessages = {};
const noListSelectedSuffix = "NoListSelected";
class ActionOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentOption: "",
            optionTitle: translate("/Account/ProductList/ActionOptions/DropDown/Heading"),
            disabled: true,
            isModalOpen: false,
            startDialogVisible: false,
            closeDialogVisible: false,
        };
    }
    UNSAFE_componentWillMount() {
        options[defaultName] = this.state.optionTitle;
        options["invent"] = translate("/Account/ProductList/ActionOptions/DropDown/PrintInvent");
        options["add"] = translate("/Account/ProductList/ActionOptions/DropDown/AddInvent");
        options["start"] = translate("/Account/ProductList/ActionOptions/DropDown/StartInvent");
        options["close"] = translate("/Account/ProductList/ActionOptions/DropDown/CloseInvent");
        feedbackMessages["start" + noListSelectedSuffix] = translate("/Account/ProductList/ActionOptions/FeebkackMessages/StartNoListSelected");
        feedbackMessages["start"] = translate("/Account/ProductList/ActionOptions/FeebkackMessages/Start");
        feedbackMessages["close" + noListSelectedSuffix] = translate("/Account/ProductList/ActionOptions/FeebkackMessages/CloseNoListSelected");
        feedbackMessages["close"] = translate("/Account/ProductList/ActionOptions/FeebkackMessages/Close");
    }
    resetState() {
        this.changeSelect(defaultName);
    }
    changeSelect(option) {
        this.props.handleDropDownSelect(DropDownListType.Actions);
        if (option !== defaultName && this.state.currentOption == option) {
            this.resetState();
            if (this.props.active)
                return;
        }
        this.setState({
            currentOption: option,
            optionTitle: options[option],
            disabled: false,
        });
    }
    handleClose() {
        this.setOpen(false);
    }
    setOpen(isOpen) {
        this.resetState();
        this.setState({
            isModalOpen: isOpen,
        });
    }
    setValidationFeedback(visible, text) {
        this.props.showValidationFeedback(visible);
        this.props.setValidationFeedbackMessage(text);
    }
    startInvent() {
        this.changeSelect("start");
        if (!!this.props.selectedLists.length &&
            !!this.props.selectedLists.every((x) => x.inventoryStatus != "ongoing"))
            this.setStartDialogVisible(true);
        else {
            this.resetState();
            this.setValidationFeedback(true, this.getFeebackMessage("start"));
        }
    }
    closeInvent() {
        this.changeSelect("close");
        if (!!this.props.selectedLists.length &&
            !!this.props.selectedLists.every((x) => x.inventoryStatus == "ongoing"))
            this.setCloseDialogVisible(true);
        else {
            this.resetState();
            this.setValidationFeedback(true, this.getFeebackMessage("close"));
        }
    }
    hasChoice() {
        return (!!this.state.currentOption &&
            this.state.currentOption != defaultName &&
            this.props.active);
    }
    setStartDialogVisible(isOpen) {
        this.setState({
            startDialogVisible: isOpen,
        }, () => {
            this.resetState();
        });
    }
    setCloseDialogVisible(isOpen) {
        this.setState({
            closeDialogVisible: isOpen,
        }, () => {
            this.resetState();
        });
    }
    getFeebackMessage(key) {
        return feedbackMessages[key +
            (!!this.props.selectedLists.filter((x) => x.selected).length
                ? ""
                : noListSelectedSuffix)];
    }
    render() {
        return (React.createElement("div", { className: styles.printOptions },
            React.createElement("div", { className: styles.printOptionsInner },
                React.createElement("div", { className: styles.selectWrapper },
                    React.createElement("div", { className: styles.dropdownWrap },
                        React.createElement(DropDownMenu, { overrideMobile: true, title: this.props.active
                                ? this.state.optionTitle
                                : options[defaultName], className: styles.dropdownAction, isActive: this.hasChoice() },
                            React.createElement(DropDownItem, { key: "ActionOptionsDropDownStart", value: "start", text: translate("/Account/ProductList/ActionOptions/DropDown/StartInvent"), onClick: (e) => this.startInvent() }),
                            React.createElement(DropDownItem, { key: "ActionOptionsDropDownClose", value: "close", text: translate("/Account/ProductList/ActionOptions/DropDown/CloseInvent"), onClick: (e) => this.closeInvent() }),
                            React.createElement(DropDownItem, { key: "ActionOptionsDropDownPrint", value: "invent", text: translate("/Account/ProductList/ActionOptions/DropDown/PrintInvent"), onClick: (e) => this.changeSelect("invent") }),
                            React.createElement(DropDownItem, { key: "ActionOptionsDropDownAdd", value: "add", text: translate("/Account/ProductList/ActionOptions/DropDown/AddInvent"), onClick: (e) => {
                                    this.setOpen(true);
                                    this.changeSelect("add");
                                } }))),
                    this.state.currentOption == "invent" && (React.createElement(PrintActions, { reportType: this.state.currentOption, visible: this.hasChoice() })))),
            React.createElement(NewListModal, { isPantry: true, isOpen: this.state.isModalOpen, handleClose: () => {
                    this.handleClose();
                } }),
            React.createElement(StartDialog, { totalAmountOfPantries: this.props.totalAmountOfPantries, isOpen: this.state.startDialogVisible, closeModal: () => {
                    this.setStartDialogVisible(false);
                }, selectedLists: this.props.selectedLists }),
            React.createElement(CloseDialog, { totalAmountOfPantries: this.props.totalAmountOfPantries, isOpen: this.state.closeDialogVisible, closeModal: () => {
                    this.setCloseDialogVisible(false);
                }, selectedLists: this.props.selectedLists })));
    }
}
export default ActionOptions;
